module.exports = window.BrowserFS.BFSRequire('process');
